import { render, staticRenderFns } from "./PageBottom.vue?vue&type=template&id=544297c4&scoped=true&"
import script from "./PageBottom.vue?vue&type=script&lang=js&"
export * from "./PageBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544297c4",
  null
  
)

export default component.exports